export default __webpack_public_path__ + "static/media/more.9e8a0922.svg";